import type { BrandId } from 'types/brands'

export type MenuEntry = {
	id: BrandId | string
	labelId: string
	subLabelId?: string
	catalogId?: string
	url?: string
	legacyUrl?: string
	menus?: MenuEntry[]
	type: MenuSectionType
	images?: MenuImageDevice
	style?: string[]
	hideIn?: HideIn
	appId?: string
}

export type BrandEntry = MenuEntry & { id: BrandId }

export enum MenuSectionType {
	Brand = 'BRAND',
	Multibrand = 'MULTIBRAND',
	Catalog = 'CATALOG',
	Edit = 'EDIT',
	Group = 'GROUP',
	Collections = 'COLLECTIONS',
	Featured = 'FEATURED',
	Editorial = 'EDITORIAL',
	Inspirational = 'INSPIRATIONAL',
	Customized = 'CUSTOMIZED',
}

interface HideIn {
	desktop: boolean
	mobile: boolean
}

interface MenuImageDevice {
	mobile?: { src: string; fontColor: string }
	desktop?: { src: string }
}

export interface MenuService {
	menus: MenuEntry[]
}

export type EntryClickMenuEventData = {
	brand: string
	subbrand?: string
	section: string
	subsection?: string
}

export type EntryParent = {
	id: string
	labelId: string
}
